// =============================================================
// 联系方式数据
// 来源：PRD §4.1.8 底部 CTA 区
// =============================================================

export const CONTACT = {
  phone1: { name: '刘先生', tel: '13705188346' },
  serviceHours: '9:00~22:00（不限工作日）',
  address: '丹阳市开发区九曲路一号丽苑大厦五楼',
  douyin: '航富通',
  wechat: '航富通官方微信',
}



// WEBPACK FOOTER //
// ./src/site/data/contact.js